import Support from "@mui/icons-material/Support";
import { Button } from "@mui/material";

import type { FC } from "react";

export const NeedHelp: FC = () => (
  <Button
    size="small"
    sx={{ color: "text.sidebar", p: 0 }}
    data-analytics-id="sidebar-need-help"
    variant="text"
    startIcon={<Support />}
    href="https://help.changeengine.com"
    target="_blank"
  >
    Need help?
  </Button>
);
